import { ref } from '@vue/runtime-core';
import axios from 'axios';
export function useCountDownLoading() {
    const loading = ref({
        isPending: false,
        timer: 0,
        isCountDown: false,
    });
    let countdownInterval = null;
    //時間を取得してローディングを開始
    const fetchStartLoading = async (url, body) => {
        const response = await axios.post(url, body);
        if (!response.data.time)
            throw new Error('Time is not found');
        startCountDownLoading(response.data.time);
    };
    //時間を指定してローディングを開始
    const startCountDownLoading = (time) => {
        loading.value.isPending = true;
        loading.value.isCountDown = true;
        loading.value.timer = time;
        if (countdownInterval) {
            clearInterval(countdownInterval);
        }
        countdownInterval = setInterval(() => {
            if (loading.value.timer > 1) {
                loading.value.timer -= 1;
            }
            else {
                clearInterval(countdownInterval);
            }
        }, 1000);
    };
    //時間なしでローディングを開始
    const startLoading = () => {
        loading.value.isPending = true;
    };
    const endLoading = () => {
        loading.value.isPending = false;
        loading.value.timer = 0;
        loading.value.isCountDown = false;
        //カウントダウンをリセット
        if (countdownInterval) {
            clearInterval(countdownInterval);
            countdownInterval = null;
        }
    };
    return {
        loading,
        fetchStartLoading,
        startCountDownLoading,
        startLoading,
        endLoading,
    };
}
